import Vue from 'vue'
import './css/index.less'
import Passenger from './components/addPassenger'
import { Row, Col, Button, Tabs, Icon, Select, Modal, InputNumber } from 'ant-design-vue'
import '@/assets/css/l8-model.less'
import moment from 'moment'
import ImgCaptcha from '@/components/imgcaptcha'
Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Select)
Vue.use(Passenger)
Vue.use(Modal)
Vue.use(Row)
Vue.use(Col)
Vue.use(InputNumber)
Vue.use(ImgCaptcha)
Vue.prototype.moment = moment
Vue.prototype.$modal = Modal
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
